import React from 'react';

export default function FormSection({ title, description, children, className = '', descriptionClassName = '', section, textPri, textMuted, dense = false, tight = false }) {
  const pad = tight ? 'p-2.5 sm:p-3' : dense ? 'p-3 sm:p-4' : 'p-4 sm:p-5';
  const headMb = tight ? 'mb-1.5' : dense ? 'mb-2' : 'mb-3 xl:mb-4';
  return (
    <div className={`rounded-2xl border ${pad} ${section} ${className}`}>
      {(title || description) && (
        <div className={headMb}>
          {title && <h3 className={`text-sm font-semibold ${textPri}`}>{title}</h3>}
          {description && <p className={`text-xs mt-0.5 ${textMuted} ${descriptionClassName}`}>{description}</p>}
        </div>
      )}
      {children}
    </div>
  );
}
